import "./App.css";
import CutomRouter from "./Routes/CutomRouter";

function App() {
  return (
    <div className="App">
      <CutomRouter />
    </div>
  );
}

export default App;
